export enum HeaderRegistryEnum {
  board,
  headerBackButtonOnly,
  projectView,
}
